import type { Faction, GameState, PieceType } from "../engine/types";
import { addPiece, createState } from "../engine/state";

const forests: Array<[number,number]>=[[2,2],[1,4],[18,2],[19,4],[1,13],[2,16],[19,13],[18,16]];
const mountains: Array<[number,number]>=[[10,2],[13,2],[14,2],[6,3],[7,3],[3,5],[4,6],[17,5],[16,6],[12,7],[8,8],[1,8],[1,9],[19,8],[19,9],[3,11],[2,12],[8,11],[12,11],[16,12],[17,12],[5,15],[6,15],[10,16],[13,15],[14,16]];

const freshSeed=():number=>{const values=new Uint32Array(1);if(globalThis.crypto?.getRandomValues)globalThis.crypto.getRandomValues(values);return values[0]||Date.now()>>>0;};

const base = (seed:number):GameState=>{
  const s=createState(21,18,seed,"SOLO");
  for(let r=0;r<s.height;r++)for(let c=0;c<s.width;c++)s.terrain[r][c]="DESERT";
  for(let c=0;c<s.width;c+=2)s.terrain[0][c]="VOID";
  for(const[c,r]of forests)s.terrain[r][c]="FOREST";for(const[c,r]of mountains)s.terrain[r][c]="MOUNTAIN";
  s.aiPlayers.REDCAT=true;s.humanFaction="EFA";s.currentFaction="EFA";s.roundStarter="EFA";s.techLevel=5;return s;
};

export function createSoloMissionOne(seed=freshSeed()):GameState{
  const s=base(seed);
  for(const[c,r]of [[9,1],[10,4],[4,9],[1,10],[16,9],[20,9],[9,14],[11,16]])s.ore[r][c]=true;
  for(const[c,r]of [[2,3],[18,3],[2,15],[18,15]])s.civilBuilding[r][c]=true;
  const setup:Array<[PieceType,Faction,number,number]>=[["CONSTRUCTION_YARD","EFA",10,8],["FACTORY","EFA",12,8],["REFINERY","EFA",9,9],["HARVESTER","EFA",10,9],["POWER_PLANT","EFA",11,9],["HELIPAD","EFA",13,9],["FIGHTER","EFA",13,9],["HELIPAD","EFA",10,11],["FIGHTER","EFA",10,11]];
  for(const p of setup){const piece=addPiece(s,...p);if(piece.type==="REFINERY")piece.facing=1;else if(piece.type==="FACTORY")piece.facing=3;}
  s.players.EFA.credits=0;s.players.REDCAT.credits=0;s.scenarioId="solo_mission_01";s.scenarioName="Mission 1 / Drone Assault";
  s.objective="Search all 4 Civil Buildings and build an MCV in addition to the Construction Yard.";s.mission.mode="SOLO_MISSION_01";s.event=`DRONE ASSAULT: ${s.objective}`;return s;
}

export function createSoloMissionTwo(seed=freshSeed()):GameState{
  const s=base(seed);
  for(const[c,r]of [[4,3],[11,3],[6,6],[14,6],[5,9],[14,9],[7,13],[12,13],[16,15],[17,8]])s.civilBuilding[r][c]=true;
  s.mission.specialCol=17;s.mission.specialRow=8;
  const left=addPiece(s,"APC","EFA",9,17);left.cargo=["RAK_INFANTRY","RAK_INFANTRY"];
  addPiece(s,"MCV","EFA",10,17);
  const right=addPiece(s,"APC","EFA",11,17);right.cargo=["RAK_INFANTRY","RAK_INFANTRY"];
  s.players.EFA.credits=20;s.players.REDCAT.credits=0;s.scenarioId="solo_mission_02";s.scenarioName="Mission 2 / Head for the Drone Hive";
  s.objective="Your MCV must reach the top edge of the Gameboard.";s.mission.mode="SOLO_MISSION_02";s.event=`HEAD FOR THE DRONE HIVE: ${s.objective}`;return s;
}
